// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:19
import { AppSettingScope_abstract } from './../abstract/SagaBase/AppSettingScope_abstract';
export class AppSettingScope extends AppSettingScope_abstract {}
